import { render } from "./UtmropList.vue?vue&type=template&id=2c10ab72&scoped=true"
import script from "./UtmropList.vue?vue&type=script&lang=js"
export * from "./UtmropList.vue?vue&type=script&lang=js"

import "./UtmropList.vue?vue&type=style&index=0&id=2c10ab72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c10ab72"]])

export default __exports__